import React from 'react';
import OutboundLink from '../../../../atoms/OutboundLink';
import { ChildrenPropType } from '../../../../services/proptypes';
import { generateGoogleExternalUrl } from '../../services/google-maps';
import { AddressPropType } from '../../types/address';
import Icon from '../Icon/Icon';
var defaultProps = {
  children: null,
  content: null,
  place: '',
  iconName: 'map',
  defaultText: 'Get directions'
};
export default function ExternalLinkMap(_ref) {
  var place = _ref.place,
    address = _ref.address,
    children = _ref.children,
    content = _ref.content,
    defaultText = _ref.defaultText,
    iconName = _ref.iconName;
  var url = generateGoogleExternalUrl(place, address);
  return /*#__PURE__*/React.createElement("div", {
    className: "external-link-map-container"
  }, /*#__PURE__*/React.createElement(OutboundLink, {
    to: url,
    "aria-label": "View Location on Map"
  }, children || content || /*#__PURE__*/React.createElement("div", null, defaultText, " ", /*#__PURE__*/React.createElement(Icon, {
    iconName: iconName
  }))));
}
ExternalLinkMap.defaultProps = defaultProps;